@if (propertyViewModel?.securityAccess == null) {
  <nts-base-toggle-text-box #baseToggleTextBox
    (onChange)="change($event)"
    (onClick)="onClick.emit()"
    [tabIndex]="tabIndex"
    [showErrorTooltip]="showErrorTooltip"
    [showErrorBorder]="showErrorBorder"
    [showTitleTooltip]="showTitleTooltip"
    [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
    [isReadOnly]="isReadOnly"
    [isDisabled]="isDisabled || !(propertyViewModel.isEnabled$ | async) || propertyViewModel?.securityAccess != null"
    [label]="propertyViewModel.metadataDescription"
    [checkStatus]="checkStatus"
    [showLabelText]="showLabelText"
    (viewReady)="onBaseViewReady()"
    [labelText]="propertyViewModel.formattedValue$ | async"
    [attr.data-check-status]="checkStatus"
    [attr.data-property-name]="propertyViewModel.propertyName">
  </nts-base-toggle-text-box>
} @else {
  <nts-base-security-text-box #baseSecurityTextBox
    (viewReady)="onBaseViewReady()"
    [accessMode]="propertyViewModel.securityAccess"
  [value]="initialValue != null ? initialValue : propertyViewModel.formattedValue$ | async"></nts-base-security-text-box>
}


